// TAPINTO® Editor Frontend - Main Entry Point
// Version: 1.0
// Date: 2025-10-01

import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.tsx'
import './index.css'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)
